import { render, staticRenderFns } from "./text-formatter.vue?vue&type=template&id=6306414c&"
import script from "./text-formatter.vue?vue&type=script&lang=js&"
export * from "./text-formatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6306414c')) {
      api.createRecord('6306414c', component.options)
    } else {
      api.reload('6306414c', component.options)
    }
    module.hot.accept("./text-formatter.vue?vue&type=template&id=6306414c&", function () {
      api.rerender('6306414c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/text-formatter.vue"
export default component.exports